<template>
  <el-dialog
      :close-on-click-modal="false"
      title="批量审批通过"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
      width="700px"
  >

    <section>
      <section>
        批量处理规则：
        <section class="tip">1）出车打款上报费用：未提交、待审核、审核不通过状态的订单，全部处理为审核通过，有费用的全部置为0；</section>
        <section class="tip">2）油/气耗上报费用：未提交、待审核、审核不通过状态的订单，全部处理为审核通过，有费用的全部处理为0；</section>
        <section class="tip">3）司机端小程序上报入口：处理费用时，同步关闭处理月份订单的，司机端小程序的费用上报入口。</section>
        <section class="tip" style="color:red">备注：该操作直接修改数据库，处理后数据无法恢复原状，请谨慎操作。如需修改，请在PC端重新上传。</section>
      </section>
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData" labelWidth="200px" style="margin-top:30px ">
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading">确认批量处理</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {getMonthFirstToLastDate} from '@qx/utils';
import {executeDealData} from 'api/system';
import {mapState} from 'vuex';

export default {

  data () {
    return {
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      formData: {
        form: [
          {
            label: '请选择处理月份(发车时间)',
            value: 'dealDate',
            type: 'date',
            default: getMonthFirstToLastDate()[0],
            attr: {
              type: 'month',
            },
          },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
            attr: {
              maxlength: 20,
            },
          },
        ],
        rules: {
          dealDate: [
            { required: true, message: '请选择处理月份', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {

    /**
     * @param {Object} visible 展示状态
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show () {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm.reset();
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await executeDealData({
        dealType: 1,
        tenantId: this.userInfo.staffTFInfo.tenantId,
        dealDate: this.formatDate(form.dealDate, 3),
        remark: form.remark,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '批量审批通过成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tip{
  margin-top: 10px;
}
</style>
